import { colors } from "./constants/colors";
import { createTheme } from "@mui/material/styles";

export const drawerWidth = 300;

export const theme = createTheme({
  palette: {
    primary: {
      main: colors.prussian_blue.DEFAULT,
    },
    secondary: {
      main: colors.blue_green.DEFAULT,
    },
    background: {
      default: colors.white.DEFAULT,
    },
  },
  typography: {
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
        },
      },
    },
  },
});

export const styles = {
  appContainer: {
    display: "flex",
  },
  appBar: (drawerOpen, drawerWidth) => ({
    backgroundColor: colors.prussian_blue.DEFAULT,
    width: !drawerOpen ? "100%" : `calc(100% - ${drawerWidth}px)`,
    transition: (theme) =>
      theme.transitions.create(["margin", "width"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    boxShadow: 1,
  }),
  title: {
    color: colors.white.DEFAULT,
    fontSize: {
      xs: "1.1rem",
      sm: "1.3rem",
      md: "1.5rem",
    },
    fontWeight: "bold",
  },
  menuIcon: {
    color: colors.white.DEFAULT,
  },
  drawer: (drawerOpen, drawerWidth) => ({
    width: `${drawerOpen ? drawerWidth : 0}px`,
    flexShrink: 0,
    "& .MuiDrawer-paper": {
      width: drawerWidth,
      boxSizing: "border-box",
      padding: 0,
      backgroundColor: colors.blue_green[900],
      touchAction: "none",
    },
  }),
  drawerHeader: {
    backgroundColor: colors.blue_green.DEFAULT,
    display: "flex",
    justifyContent: "center",
    color: colors.sky_blue[100],
  },
  drawerHeaderText: {
    color: colors.white.DEFAULT,
    fontWeight: "bold",
  },
  drawerContent: {
    overflow: "auto",
    p: 2,
    paddingTop: 5,
  },
  mainContent: {
    display: "flex",
    width: "100%",
    height: "100vh",
    backgroundColor: colors.white.DEFAULT,
  },
  mainBox: {
    flexGrow: 1,
    p: 3,
    // width: "100%", //TODO: was 50% changing didn't work
    transition: (theme) =>
      theme.transitions.create(["margin", "width"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    // maxWidth: "1500px", // TODO: was 800px changing didn't work
    margin: "0 auto",
  },
  resultsContainer: {
    width: "100%",
  },
  toolbar: {
    display: "flex",
    justifyContent: "space-between",
  },
  toolbarRight: {
    display: "flex",
    alignItems: "center",
  },
};
